import type {
  FormattedArticle,
  FormattedProduct,
  FormattedRecipes,
  FormattedTipsAndTrick,
} from 'types/AlgoliaResults';
import type { SearchResultCard } from '..';
import { mapAlgoliaRecipeToSearchCard } from '../AlgoliaRecipeToSearchCard/AlgoliaRecipeToSearchCard';
import { mapAlgoliaTipsToSearchCard } from '../AlgoliaTipsToSearchCard/AlgoliaTipsToSearchCard';
import { mapAlogliaArticleToSearchCard } from '../AlogliaArticleToSearchCard/AlogliaArticleToSearchCard';
import { mapAlogliaProductToSearchCard } from '../AlogliaProductToSearchCard/AlogliaProductToSearchCard';
import type { PathTranslations } from 'service/localization/getPathTranslations';

export const mapGlobalSearchResultsToCards = (
  items: any[],
  labels: Record<string, string>,
  pathTranslations: PathTranslations,
): SearchResultCard[] =>
  items.reduce((all, current) => {
    if (current.objectType === 'RECIPES') {
      return [
        ...all,
        mapAlgoliaRecipeToSearchCard(current as FormattedRecipes, labels, pathTranslations),
      ];
    }
    if (current.objectType === 'TIPS_TRICKS') {
      return [
        ...all,
        mapAlgoliaTipsToSearchCard(current as FormattedTipsAndTrick, labels, pathTranslations),
      ];
    }
    if (current.objectType === 'PRODUCTS') {
      return [
        ...all,
        mapAlogliaProductToSearchCard(current as FormattedProduct, labels, pathTranslations),
      ];
    }
    if (current.objectType === 'ARTICLES') {
      return [
        ...all,
        mapAlogliaArticleToSearchCard(current as FormattedArticle, labels, pathTranslations),
      ];
    }
    return all;
  }, []);
